import { CareRecipientId } from "./CareRecipientId";
import { CareRecipientName } from "./CareRecipientName";
import { DateObject } from "../fundamental/DateObject";
import { CareRecipientHouseId } from "./CareRecipientHouseId";
import { CareRecipient } from "./CareRecipient";
import { ServiceProviderId } from "../service_provider/ServiceProviderId";
import { DateTime } from "../fundamental/DateTime";
import { Sensor } from "./Sensor";
import { CareRecipientClassification } from "./CareRecipientClassification";
import { DiseaseLabel } from "./Disease";
import { BranchCode } from "./BranchCode";
import { CustomerCode } from "./CustomerCode";

const CareRecipientWithSensorType = Symbol();

export class CareRecipientWithSensor {
    [CareRecipientWithSensorType]: any;

    careRecipient: CareRecipient;
    serviceProviderId: ServiceProviderId | null;
    dataSyncStartTime: DateTime | null;
    dataSyncEndTime: DateTime | null;
    sensors: (Sensor | undefined)[];
    classification: CareRecipientClassification | null;
    diseases: DiseaseLabel[] | null;
    alertPeriod: {
        start: DateObject,
        end: DateObject
    } | null;
    alertPause: boolean | null;

    private constructor(
        careRecipientId: CareRecipientId,
        careRecipientName: CareRecipientName,
        birthday: DateObject | null,
        houseId: CareRecipientHouseId | null,
        serviceProviderId: ServiceProviderId | null,
        dataSyncStartTime: DateTime | null,
        dataSyncEndTime: DateTime | null,
        sensors: (Sensor | undefined)[],
        classification: CareRecipientClassification | null,
        diseases: DiseaseLabel[] | null,
        alertPeriodStart: DateObject | null,
        alertPeriodEnd: DateObject | null,
        alertPause: boolean | null,
        branchCode: BranchCode| null = null,
        customerCode: CustomerCode| null = null,
    ) {
        this.careRecipient = CareRecipient.from(careRecipientId, careRecipientName, birthday, houseId, customerCode, branchCode);
        this.serviceProviderId = serviceProviderId;
        this.dataSyncStartTime = dataSyncStartTime;
        this.dataSyncEndTime = dataSyncEndTime;
        this.sensors = sensors;
        this.classification = classification;
        this.diseases = diseases;
        this.alertPeriod = (alertPeriodStart && alertPeriodEnd) ? { start: alertPeriodStart, end: alertPeriodEnd } : null;
        this.alertPause = alertPause;
    }

    static from(
        careRecipientId: CareRecipientId,
        careRecipientName: CareRecipientName,
        birthday: DateObject | null,
        houseId: CareRecipientHouseId | null,
        serviceProviderId: ServiceProviderId | null,
        dataSyncStartTime: DateTime | null,
        dataSyncEndTime: DateTime | null,
        sensors: (Sensor | undefined)[],
        classification: CareRecipientClassification | null,
        diseases: DiseaseLabel[] | null,
        alertPeriodStart: DateObject | null,
        alertPeriodEnd: DateObject | null,
        alertPause: boolean | null,
        branchCode: BranchCode| null = null,
        customerCode: CustomerCode| null = null,
    ): CareRecipientWithSensor {
        return new CareRecipientWithSensor(
            careRecipientId,
            careRecipientName,
            birthday,
            houseId,
            serviceProviderId,
            dataSyncStartTime,
            dataSyncEndTime,
            sensors,
            classification,
            diseases,
            alertPeriodStart,
            alertPeriodEnd,
            alertPause,
            branchCode,
            customerCode,
        );
    }
}

export type CareRecipientWithSensorJson = {
    id: string,
    name: string,
    houseId: string,
    birthday: string,
    serviceProviderId: string,
    dataSyncStartTime: string | null,
    dataSyncEndTime: string | null,
    sensors: [{
        sensor: string
    }],
    classification: string | null,
    diseases: DiseaseLabel[] | null,
    alertPeriod: {
        start: string,
        end: string
    } | null,
    alertPause: boolean | null,
    customerCode: string | null,
    branchCode: string | null,
};
